import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 10,
    padding: theme.spacing(4, 0),
    backgroundImage:
      'radial-gradient(circle farthest-side, #FFFFFF 5%, transparent 5%, transparent 100%)',
    backgroundSize: 10,
    backgroundPosition: 0,
  },
}));

const DottedDivider = () => {
  const classes = useStyles();
  return <div className={classes.root} />;
};

export default DottedDivider;
